<template>
  <b-modal
      v-model="showModal"
      hide-footer
      :title="title"
      class="v-modal-custom"
      body-class="p-0"
      scrollable
      centered
  >
    <div class="modal-body border-top">
      <div class="mb-3">
        <label class="form-label">{{ $t('page.atlas-analysis.describe') }}</label>
        <b-form-textarea
            v-model="note"
            :rows="2"
            :readonly="readOnly"
        ></b-form-textarea>
      </div>
      <div class="accordion accordion-flush" id="accordionFlushExample" style="max-height: 30vh;overflow-y: auto;">
        <div class="accordion-item">
          <h2 class="accordion-header" id="flush-headingOne">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
              {{ $t('page.history-explain') }}
            </button>
          </h2>
          <div id="flush-collapseOne" class="accordion-collapse collapse show" aria-labelledby="flush-headingOne"
               data-bs-parent="#accordionFlushExample">
            <div>
              <div
                v-for="(item, index) in notes"
                :key="index"
                class="border-bottom py-3"
              >
                <div class="mb-2 d-flex align-items-center">
                  <span>{{ item.user_txt }}</span>
                  <span class="ms-3 text-muted">{{ formatDatetime(item.created_at, 'YYYY年MM月DD日 HH:mm:ss') }}</span>
                </div>
                <div>
                  {{  item.content }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer v-modal-footer" v-if="!readOnly">
      <b-button type="button" variant="light" @click="showModal = false">{{this.$t('base.cancel')}}
      </b-button>
      <b-button type="button" variant="primary" @click="saveNote">{{this.$t('base.save')}}</b-button>
    </div>
  </b-modal>
</template>
<script>
import { formatDatetime } from "@/helpers/common";

export default {
  props: {

  },
  data () {
    return {
      note: '',
      notes: [],
      showModal: false,
      title: this.$t('page.explanation'),
      form: {},
      readOnly: false,
      task_id: null,
    }
  },
  methods: {
    formatDatetime,
    open(params = null, readOnly = false) {
      this.note = ''
      this.readOnly = readOnly
      this.task_id = params.task_id
      this.notes = params.notes || []
      this.showModal = true
    },
    saveNote () {
      this.$emit('saveNote', {
        task: this.task_id,
        content: this.note
      })
    },
    close() {
      this.showModal = false
    }
  }
}
</script>
